@if (initialized) {

    @if (activeNavigationItem?.action == 'outletContentType') {
        @if (outletContentTypeWidgetData) {
            <mvs-widget [widgetData]="outletContentTypeWidgetData"></mvs-widget>
        }
    } @else if (activeNavigationItem?.action == 'outletContentTypeField') {
        @if (outletContentTypeFieldWidgetData) {
            <mvs-widget [widgetData]="outletContentTypeFieldWidgetData"></mvs-widget>
        }
    } @else if (activeNavigationItem?.action == 'outletContent') {
        @if (outletContentWidgetData) {
            <mvs-widget [widgetData]="outletContentWidgetData"></mvs-widget>
        }
    }
}